import { render, staticRenderFns } from "./TotalMentalHealthSelectCoach.vue?vue&type=template&id=48df214f"
import script from "./TotalMentalHealthSelectCoach.vue?vue&type=script&lang=js"
export * from "./TotalMentalHealthSelectCoach.vue?vue&type=script&lang=js"
import style0 from "./TotalMentalHealthSelectCoach.vue?vue&type=style&index=0&id=48df214f&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports